import loc from 'owa-localize';
import type { DataCollector } from 'owa-diagnostics-data-collection';
import { lazyRegisterDataCollectorIfNotRegistered } from 'owa-diagnostics-data-collection';
import { keytipsDiagnosticDataDescription } from './keytipsDataCollector.locstring.json';
import { getLocalKeytipsEnabledStatus } from '../selectors/getLocalKeytipsEnabledStatus';
import { KeytipManager } from '@fluentui/react';

export const registerKeytipsDataCollector = async (): Promise<void> => {
    const getKeytipsDataCollector: DataCollector = {
        dataCollectionAction,
        name: 'RibbonKeytipsInformation',
        odsFileDescription: 'Ribbon keytips data',
        description: loc(keytipsDiagnosticDataDescription),
    };
    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(getKeytipsDataCollector);
};

const dataCollectionAction = (): Promise<string> => {
    const { inKeytipMode } = KeytipManager.getInstance();
    const debugInfo = {
        areKeytipsEnabled: getLocalKeytipsEnabledStatus(),
        isDisplayingKeytips: inKeytipMode,
    };
    return Promise.resolve(JSON.stringify(debugInfo));
};
